import {
  ProviderRegistrationProfessionalCredentialsInner,
  ProviderRegistrationProfessionalCredentialsInnerTypeEnum,
} from "@asd/customer-portal-api";
import { Checkbox, FormControlLabel, Stack, TextField, Typography } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";

import { CREDENTIAL_OPTIONS, PROVIDER_REGISTRATION_TITLE_PROPS } from "~/utils/providerRegistrationHelpers";
import BooleanRadioGroup from "./BooleanRadioGroup";

const Experience = () => {
  const { control } = useFormContext();

  return (
    <Stack direction="column" spacing={4}>
      <Stack direction="column" spacing={2}>
        <Typography align="left" {...PROVIDER_REGISTRATION_TITLE_PROPS}>
          Do you have experience as a caregiver?
        </Typography>
        <BooleanRadioGroup control={control} name="experience.caregiverExperience" />
      </Stack>
      <Stack direction="column" spacing={2}>
        <Typography align="left" {...PROVIDER_REGISTRATION_TITLE_PROPS}>
          Do you have any of the below licenses, credentials, or certifications?
        </Typography>
        <Controller
          control={control}
          defaultValue={[]}
          name="experience.professionalCredentials"
          render={({ field, fieldState: { error } }) => (
            <>
              {CREDENTIAL_OPTIONS.map(([enumValue, label]) => {
                const isThisNA = enumValue === ProviderRegistrationProfessionalCredentialsInnerTypeEnum.not_applicable;
                const isThisOther = enumValue === ProviderRegistrationProfessionalCredentialsInnerTypeEnum.other;

                const existing = field.value.find((value: ProviderRegistrationProfessionalCredentialsInner) => value.type === enumValue);
                const isNASelected = field.value.some(
                  (value: ProviderRegistrationProfessionalCredentialsInner) =>
                    value.type === ProviderRegistrationProfessionalCredentialsInnerTypeEnum.not_applicable,
                );
                const isAnyNonNASelected = field.value.some(
                  (value: ProviderRegistrationProfessionalCredentialsInner) =>
                    value.type !== ProviderRegistrationProfessionalCredentialsInnerTypeEnum.not_applicable,
                );

                const isDisabled = (isNASelected && !isThisNA) || (isAnyNonNASelected && isThisNA);
                const isOtherActive = typeof existing?.otherText === "string";

                return (
                  <Stack key={enumValue} direction="row">
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={!!existing || (isThisOther && isOtherActive)}
                          disabled={isDisabled}
                          onChange={(e) => {
                            if (!e.target.checked) {
                              field.onChange(
                                field.value.filter((value: ProviderRegistrationProfessionalCredentialsInner) => value.type !== enumValue),
                              );
                            } else {
                              field.onChange([...field.value, isThisOther ? { type: enumValue, otherText: "" } : { type: enumValue }]);
                            }
                          }}
                        />
                      }
                      label={isThisOther ? "" : label}
                    />
                    {isThisOther && (
                      <TextField
                        disabled={isDisabled || !isOtherActive}
                        error={!isDisabled && isOtherActive && !!error}
                        helperText={!isDisabled && isOtherActive && error ? error.message : null}
                        label="Other"
                        onChange={(e) => {
                          field.onChange(
                            field.value.map((value: ProviderRegistrationProfessionalCredentialsInner) =>
                              value.type === enumValue ? { ...value, otherText: e.target.value } : value,
                            ),
                          );
                        }}
                        value={existing?.otherText || ""}
                      />
                    )}
                  </Stack>
                );
              })}
            </>
          )}
          rules={{
            validate: (formValue) => {
              const other = formValue?.find(
                (value: ProviderRegistrationProfessionalCredentialsInner) =>
                  value.type === ProviderRegistrationProfessionalCredentialsInnerTypeEnum.other,
              );
              if (other && !other.otherText?.length) {
                return "Value is required if checked";
              }
              return true;
            },
          }}
        />
      </Stack>
    </Stack>
  );
};

export default Experience;
